// extracted by mini-css-extract-plugin
export default {"posReports":"style--posReports--c98dab","report":"style--report--a1c2a0","goBackLink":"style--goBackLink--92f2d3"};